import React, { useRef, useState, useEffect, useCallback } from "react";
import { Box, Typography } from "@mui/material";
import { BarChart } from "Moleculas/BarChart/BarChart";
import { Legends } from "Atoms/Charts/Legends";
import sectionStyles from "./styles";

function ChartSection({
  title,
  subtitle,
  description,
  data,
  series,
  type = "stacked",
  chartStyles,
  xLabel,
  yLabel,
  footnotes,
  height = 500,
  xMaxOverride,
}) {
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);

  const updateWidth = useCallback(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }
  }, []);

  useEffect(() => {
    updateWidth();

    const observer = new ResizeObserver(updateWidth);
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, [updateWidth]);

  return (
    <Box sx={sectionStyles.container}>
      {title && <Typography sx={sectionStyles.title}>{title}</Typography>}
      {subtitle && <Typography sx={sectionStyles.subtitle}>{subtitle}</Typography>}
      {description && <Typography sx={sectionStyles.description}>{description}</Typography>}

      <Legends series={series} />

      <Box sx={{ display: "flex", alignItems: "stretch", mt: 2 }}>
        {yLabel && (
          <Box sx={{ display: "flex", width: "1%", position: "relative" }}>
            <Typography sx={sectionStyles.yAxisLabel}>{yLabel}</Typography>
          </Box>
        )}
        <Box ref={containerRef} sx={{ flex: 1, overflow: "hidden" }}>
          { data === null
            ? <Typography>Cargando...</Typography>
            : containerWidth > 0 && data.length > 0 && (
            <BarChart
              data={data}
              width={containerWidth}
              height={height}
              type={type}
              series={series}
              styles={chartStyles}
              xMaxOverride={xMaxOverride}
            />
          )}
        </Box>
      </Box>

      {xLabel && (
        <Box>
          <Typography sx={sectionStyles.axisLabel}>{xLabel}</Typography>
        </Box>
      )}

      {footnotes && footnotes.length > 0 && (
        <Typography sx={sectionStyles.footnote}>
          {footnotes.map((line, index) => (
            <React.Fragment key={`footnote-${index}`}>
              {line}
              {index < footnotes.length - 1 ? <br /> : null}
            </React.Fragment>
          ))}
        </Typography>
      )}
    </Box>
  );
}

export default ChartSection;
